import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LoginasModal, { loginasModalId } from './modal/LoginasModal';
import useImpersonation from './useImpersonation';

const useLoginasModal = () => {
  const { t } = useTranslation();
  const { notifyError } = useNotify();
  const { openModal, closeModal } = useAppModal();
  const { impersonateUser } = useImpersonation();
  const navigate = useNavigate();

  const handleSubmit = async ({ email }: { email: string }) => {
    try {
      const accessToken = await impersonateUser(email[0]);

      closeModal(loginasModalId);

      if (accessToken) {
        localStorage.setItem('access_token', accessToken);

        navigate('/dashboard');
        window.location.reload();
      } else {
        notifyError(t('common.loginas.errorLogin'));
      }
    } catch (error) {
      notifyError(t('common.loginas.errorLogin'));
    }
  };

  const openLoginasModal = () => {
    openModal({
      id: loginasModalId,
      customContent: <LoginasModal onSubmit={handleSubmit} />,
    });
  };

  return { openLoginasModal };
};

export default useLoginasModal;
